import { bodyBgGradient2 } from './BodyBgStore';

import { bodyBgGradient2Default } from './BodyBgStoreDefaults';

export const resetBodyBgGradient2 = () => bodyBgGradient2.set(bodyBgGradient2Default);
